import { deleteDistanceSurcharge, IDistanceSurcharge } from "@/api/settings";
import { Delete } from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface Props {
    distanceSurcharge: IDistanceSurcharge;
}
export const DistanceSurchargeDeleteIcon = ({ distanceSurcharge }: Props) => {
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();

    const deleteMutation = useMutation({
        mutationFn: deleteDistanceSurcharge,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-distance-surcharges"],
            });
        },
    });

    const handleDelete = () => {
        deleteMutation.mutate(distanceSurcharge.id);
        setOpen(false);
    };

    return (
        <>
            <IconButton
                color="error"
                onClick={() => {
                    setOpen(true);
                }}
            >
                <Delete />
            </IconButton>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle id="alert-dialog-title">
                    Delete Distance Surcharge?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this distance surcharge?
                        <br />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button color="error" onClick={handleDelete} autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
